import { environment } from '../../environments/environment';

export function getBoatImageUrl(imagePath: string): string {
  if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
    return imagePath;
  }
  return `${environment.assetUrl}/gambar_kapal/${imagePath}`;
}

export function getAccommodationImageUrl(imagePath: string): string {
  if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
    return imagePath;
  }
  return `${environment.assetUrl}/accomodation/${imagePath}`;
}

export function getArticleImageUrl(imagePath: string): string {
  if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
    return imagePath;
  }
  return `${environment.assetUrl}/article/${imagePath}`;
}

export function getPriceImageUrl(imagePath: string): string {
  if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
    return imagePath;
  }
  return `${environment.assetUrl}/price/${imagePath}`;
}

export function getGuestDocumentUrl(
  kode_booking: string,
  guest_index: number,
  token: string,
): string {
  if (!kode_booking || token == null || token === '') return '';
  return `${environment.apiUrl}/booking-guests/${kode_booking}/${guest_index}/document?token=${encodeURIComponent(token)}`;
}
